const hasLocalhost = (hostname: string) =>
  Boolean(
    hostname.match(/localhost/) ||
    hostname.match(/127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}/)
  );
const isLocalhost = hasLocalhost(window.location.hostname);
export const environment = {
  stage: 'qual',
  userPoolId: 'eu-west-1_ZifETEFAt',
  region: 'eu-west-1',
  clientId: '77m510sv0ss7oug1tb9g5rhoks',
  cognitoDomainPrefix: 'cxp-admins-dev',
  cognitoRedirectUri: isLocalhost
    ? 'http://localhost:4200/secure'
    : 'https://mapping.catenax-dev2.draexlmaier.solutions/secure',
  cognitoLogoutUri: isLocalhost
    ? 'http://localhost:4200/login'
    : 'https://mapping.catenax-dev2.draexlmaier.solutions/login',
  mappingPublicApiUrl: 'https://b4c37jc4le.execute-api.eu-west-1.amazonaws.com/qual',
};
